var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { AsideSection } from '../elements/aside-section';
import { ContentNode } from './content-node';
var cls = classNames('slice-sidebar-section-layout');
export var SliceSidebarSectionLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var IntroStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(4))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 300;\n    padding-bottom: ", ";\n  "], ["\n    font-weight: 300;\n    padding-bottom: ", ";\n  "])), theme.UNIT(4))
});
var OutroStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  NAME: 'SliceSidebarSectionLayout',
  Container: styled(AsideSection)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Intro: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(ContentNode)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Outro: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles)
};
export var SliceSidebarSectionLayout = function (props) {
  var componentProps = useComponentProps(My.NAME, SliceSidebarSectionLayoutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var outro = entity.outro,
    intro = entity.intro,
    content = entity.content;
  var hasIntro = !!(intro === null || intro === void 0 ? void 0 : intro.text);
  var hasContent = !!(content === null || content === void 0 ? void 0 : content.text);
  var hasOutro = !!(outro === null || outro === void 0 ? void 0 : outro.text);
  return React.createElement(My.Container, {
    label: entity.label,
    className: cls.name(className)
  }, hasIntro && React.createElement(My.Intro, {
    entity: intro
  }), hasContent && React.createElement(My.Content, {
    entity: content
  }), children, hasOutro && React.createElement(My.Outro, {
    entity: outro
  }));
};
SliceSidebarSectionLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;